import Screen from './Screen';
import DecorationEditScene from '../decoration/DecorationEditScene';
import { DecorationRoomID } from 'src/replicant/decoration/decoration.ruleset';
import StateObserver from 'src/StateObserver';
import { setHudVisibility } from 'src/state/ui';
import features from 'src/replicant/ruleset/features';

type Args = [{ room: DecorationRoomID }];
export default class DecorationScreen extends Screen<Args> {
  private scene!: DecorationEditScene;

  public get currentScene() {
    return this.scene;
  }

  public showScreen(...[{ room }]: Args) {
    const { user } = StateObserver.getState();
    StateObserver.dispatch(
      setHudVisibility({
        header: false,
        footer: false,
      }),
    );

    this.popAll();

    this.scene = new DecorationEditScene(room);

    this.push(this.scene.getView());

    // Mark decoration as seen
    this.waitForHide().then(() =>
      StateObserver.invoke.markDecorationItemsAsSeen(),
    );
  }
}
